// extracted by mini-css-extract-plugin
module.exports = {"card":"card-module--card--1iXFM","title":"card-module--title--1oRMM","close":"card-module--close--3Ez7I","body":"card-module--body--3lzx9"};